import Spinner from 'components/Spinner/Spinner'
import {
  OauthPlatform,
  useGetOauthTokensQuery,
} from 'graphql/generated/graphql'
import { usePageNavigation } from 'hooks/useNavigation'
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

export default function Instagram(): JSX.Element {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('code')
  const { navigateToDashboard } = usePageNavigation()

  const { loading, data } = useGetOauthTokensQuery({
    variables: {
      code: code ?? '',
      platform: OauthPlatform.Instagram,
    },
    skip: !code, // ✅ now correctly inline
  })

  useEffect(() => {
    if (data?.oauth?.accessToken) {
      localStorage.setItem('instagramToken', data.oauth.accessToken)
      navigateToDashboard()
    }
  }, [data, navigateToDashboard])

  if (!code) return <>Missing Code</>
  if (loading) return <Spinner />
  if (!data) return <>Something went wrong</>

  return <>Successful</>
}
